import { render, staticRenderFns } from "./NotificationFeedback.vue?vue&type=template&id=12e9401b&"
import script from "./NotificationFeedback.vue?vue&type=script&lang=js&"
export * from "./NotificationFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports